import React from "react";
import { FEATURED_IN } from "@/lib/brand";

export default function FeaturedIn() {
  return (
    <section data-testid="featured-in-section" className="py-20 md:py-28 px-6 md:px-12 border-y hairline">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex items-center gap-6 mb-12">
          <div className="h-px flex-1 bg-white/10"></div>
          <p className="font-overline text-silver-muted">— Featured In —</p>
          <div className="h-px flex-1 bg-white/10"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-x-8 gap-y-10 items-center justify-items-center">
          {FEATURED_IN.map((logo) => (
            <span
              key={logo.name}
              data-testid={`featured-${logo.name.toLowerCase().replace(/\s+/g, '-').replace(/'/g, '')}`}
              className="text-silver/70 hover:text-silver transition-colors duration-300 text-2xl md:text-3xl whitespace-nowrap select-none"
              style={{
                fontFamily: logo.font,
                fontWeight: logo.weight,
                fontStyle: logo.style,
                letterSpacing: logo.tracking || "0",
                textTransform: logo.upper ? "uppercase" : "none",
              }}
            >
              {logo.name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
